import React from 'react';

interface MilestoneDateDisplayProps {
  date: Date | string | undefined;
  label: string;
  icon?: React.ReactNode;
  className?: string;
  textColor?: string;
}

const MilestoneDateDisplay: React.FC<MilestoneDateDisplayProps> = ({
  date,
  label,
  icon,
  className = '',
  textColor = 'text-gray-600',
}) => {
  const formatDate = (date: Date | string | undefined) => {
    if (!date) return '';
    const d = date instanceof Date ? date : new Date(date);
    return d.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  if (!date) return null;

  return (
    <div className={`flex items-center gap-2 ${textColor} ${className}`}>
      {icon && <span className="flex-shrink-0">{icon}</span>}
      <span>
        <strong>{label}:</strong> {formatDate(date)}
      </span>
    </div>
  );
};

export default MilestoneDateDisplay;

